var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content resize" },
    [
      _c("e-breadcrumbs"),
      _c("h1", { staticClass: "page_title" }, [
        _vm._v(_vm._s(_vm.$t("msg.CART010G010.011"))),
      ]),
      _c(
        "form",
        {
          key: _vm.formKey,
          attrs: { id: "frm" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.onSearchSubmit()
            },
          },
        },
        [
          _c("input", {
            staticStyle: { display: "none" },
            attrs: { type: "text", id: "_temp" },
          }),
          _c("div", { staticClass: "content_box mt10" }, [
            _c("table", { staticClass: "tbl_search" }, [
              _vm._m(0),
              _c("tbody", [
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$t("msg.CART010G010.015")))]),
                  _c("td", [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.params.dtKnd,
                            expression: "params.dtKnd",
                          },
                        ],
                        attrs: { id: "" },
                        on: {
                          change: [
                            function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.params,
                                "dtKnd",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                            function ($event) {
                              return _vm.changeSelectFuc()
                            },
                          ],
                        },
                      },
                      [
                        _c("option", { attrs: { value: "BL" } }, [
                          _vm._v(_vm._s(_vm.$t("msg.CART010G010.012"))),
                        ]),
                        _c("option", { attrs: { value: "BK" } }, [
                          _vm._v(_vm._s(_vm.$t("msg.CART010G010.014"))),
                        ]),
                      ]
                    ),
                  ]),
                  _c("td", { staticClass: "pl0" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.params.blNo,
                          expression: "params.blNo",
                        },
                      ],
                      key: _vm.params.dtKnd,
                      attrs: {
                        type: "text",
                        id: "blNo",
                        name: `cargoSearchKey_${_vm.params.dtKnd}`,
                      },
                      domProps: { value: _vm.params.blNo },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.params, "blNo", $event.target.value)
                          },
                          function ($event) {
                            return _vm.checkValidationAll()
                          },
                        ],
                      },
                    }),
                  ]),
                  _c("td", [
                    _c(
                      "button",
                      {
                        staticClass: "button blue sh",
                        attrs: { type: "submit" },
                      },
                      [_vm._v(_vm._s(_vm.$t("msg.CART010G010.055")))]
                    ),
                  ]),
                  _vm.searchFlag === "Y" &&
                  _vm.noDataFlag === "N" &&
                  _vm.lang === "KOR" &&
                  _vm.bookingInfo.spcShiprYn === "Y" &&
                  (_vm.params.dtKnd === "BL" || _vm.params.dtKnd === "BK")
                    ? _c(
                        "td",
                        {
                          staticStyle: { float: "right" },
                          attrs: { id: "subscriptionBtn" },
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "button blue sh",
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.openSubscriptionPopup()
                                },
                              },
                            },
                            [_vm._v("구독")]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]),
            ]),
          ]),
          _vm.searchFlag === "Y" && _vm.noDataFlag === "N"
            ? _c(
                "div",
                { staticClass: "content_box mt10" },
                [
                  _vm.searchFlag === "Y" && _vm.noDataFlag === "N"
                    ? _c("div", { staticClass: "mt10" }, [
                        _vm.cntrList.length > 0
                          ? _c("p", { staticClass: "text_right font_medium" }, [
                              _vm._v("(E) Estimated  "),
                              _c("span", { staticClass: "color_red" }, [
                                _vm._v("(A) Actual"),
                              ]),
                            ])
                          : _vm._e(),
                        _c(
                          "table",
                          {
                            staticClass: "tbl_col mt5 th_pre_line",
                            class: { tbl_compact: _vm.registryNo === "Y" },
                          },
                          [
                            _c(
                              "colgroup",
                              _vm._l(_vm.topGridColWidths, function (w, widx) {
                                return _c("col", {
                                  key: "topGridCol_" + widx,
                                  style: { width: w },
                                })
                              }),
                              0
                            ),
                            _c("thead", [
                              _c("tr", [
                                _c("th", [
                                  _vm._v(_vm._s(_vm.$t("msg.CART010G010.012"))),
                                  _c("br"),
                                  _vm._v(
                                    _vm._s(
                                      "(" + _vm.$t("msg.ONEX010T010.093") + ")"
                                    )
                                  ),
                                ]),
                                _c("th", [
                                  _vm._v(_vm._s(_vm.$t("msg.CART010G010.014"))),
                                ]),
                                _c("th", [
                                  _vm._v(_vm._s(_vm.$t("msg.CART010G010.013"))),
                                ]),
                                _c("th", [
                                  _vm._v(_vm._s(_vm.$t("msg.CART010G010.016"))),
                                ]),
                                _c("th", [_vm._v("CGO")]),
                                _c("th", [
                                  _vm._v(_vm._s(_vm.$t("msg.CART010G010.077"))),
                                ]),
                                _c("th", [
                                  _vm._v(_vm._s(_vm.$t("msg.CART010G010.078"))),
                                ]),
                                _c("th", [
                                  _vm._v(_vm._s(_vm.$t("msg.CART010G010.079"))),
                                ]),
                                _c("th", [
                                  _vm._v(_vm._s(_vm.$t("msg.CART010G010.080"))),
                                ]),
                                _c("th", [
                                  _vm._v(_vm._s(_vm.$t("msg.CART010G010.081"))),
                                ]),
                                _c("th", [
                                  _vm._v(_vm._s(_vm.$t("msg.CART010G010.082"))),
                                ]),
                                _c(
                                  "th",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.registryNo === "Y",
                                        expression: "registryNo === 'Y'",
                                      },
                                    ],
                                  },
                                  [_vm._v("REGISTRY NO. ")]
                                ),
                              ]),
                            ]),
                            _c("tbody", [
                              _vm.cntrList.length > 0
                                ? _c("tr", [
                                    _c("td", [
                                      _vm._v(
                                        " " + _vm._s(_vm.cntrList[0].blNo) + " "
                                      ),
                                      _vm.cntrList[0].issueStatus !== "99"
                                        ? _c(
                                            "span",
                                            { staticClass: "label2 blue" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getIssueStatus(
                                                    _vm.cntrList[0].issueStatus
                                                  )
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                                    _c("td", { staticClass: "td_left_line" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.parseBkNo(_vm.cntrList[0].bkgNo)
                                        )
                                      ),
                                    ]),
                                    _c(
                                      "td",
                                      { staticClass: "td_left_line" },
                                      [
                                        _vm._l(
                                          _vm.cntrList,
                                          function (cvo, cidx) {
                                            return _c(
                                              "p",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.cntrList.length <= 5,
                                                    expression:
                                                      "cntrList.length <= 5",
                                                  },
                                                ],
                                                key: "sumCntr_" + cidx,
                                              },
                                              [
                                                cvo.cntrNo ==
                                                _vm.detailParams.cntrNo
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "cntrNo_area",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(cvo.cntrNo)
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "cntrNo_area link",
                                                        attrs: { href: "#" },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.setCntrList(
                                                              cvo.cntrNo,
                                                              cidx
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(cvo.cntrNo)
                                                        ),
                                                      ]
                                                    ),
                                              ]
                                            )
                                          }
                                        ),
                                        _vm.cntrList.length > 5
                                          ? _c("p", [
                                              _c(
                                                "select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.selectCntrNo,
                                                      expression:
                                                        "selectCntrNo",
                                                    },
                                                  ],
                                                  on: {
                                                    change: [
                                                      function ($event) {
                                                        var $$selectedVal =
                                                          Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function (o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function (o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                        _vm.selectCntrNo =
                                                          $event.target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                      },
                                                      function ($event) {
                                                        return _vm.setCntrList()
                                                      },
                                                    ],
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.cntrList,
                                                  function (cvo, cidx) {
                                                    return _c(
                                                      "option",
                                                      {
                                                        key:
                                                          "sumCntrOpt_" + cidx,
                                                        domProps: {
                                                          value: cvo.cntrNo,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(cvo.cntrNo)
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ])
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                    _c("td", { staticClass: "td_left_line" }, [
                                      _vm._v(
                                        _vm._s(_vm.selectedCntr.cntrSzCd) +
                                          " " +
                                          _vm._s(_vm.selectedCntr.cntrTypCd)
                                      ),
                                    ]),
                                    _c("td", { staticClass: "td_left_line" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getCgoTypNm(
                                            _vm.selectedCntr.shprVanYn,
                                            _vm.selectedCntr.cgoTypCd
                                          )
                                        )
                                      ),
                                    ]),
                                    _c("td", { staticClass: "td_left_line" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.isVepCgo
                                            ? "-"
                                            : _vm.fnCntRate(
                                                _vm.legSummary.polMtyOutCnt,
                                                _vm.legSummary.totCnt
                                              )
                                        )
                                      ),
                                    ]),
                                    _c("td", { staticClass: "td_left_line" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.isVepCgo
                                            ? "-"
                                            : _vm.fnCntRate(
                                                _vm.legSummary.polFulInCnt,
                                                _vm.legSummary.totCnt
                                              )
                                        )
                                      ),
                                    ]),
                                    _c("td", { staticClass: "td_left_line" }, [
                                      _vm.legSummary.loadingEstDt
                                        ? _c(
                                            "p",
                                            {
                                              class: _vm.legSummary.loadingActDt
                                                ? "color_gray"
                                                : "",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.fnEaDateTime(
                                                    _vm.legSummary.loadingEstDt,
                                                    "E"
                                                  )
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.legSummary.loadingActDt
                                        ? _c(
                                            "p",
                                            { staticClass: "color_red" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.fnEaDateTime(
                                                    _vm.legSummary.loadingActDt,
                                                    "A"
                                                  )
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                                    _c("td", { staticClass: "td_left_line" }, [
                                      _vm.legSummary.dischargingEstDt
                                        ? _c(
                                            "p",
                                            {
                                              class: _vm.legSummary
                                                .dischargingActDt
                                                ? "color_gray"
                                                : "",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.fnEaDateTime(
                                                    _vm.legSummary
                                                      .dischargingEstDt,
                                                    "E"
                                                  )
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.legSummary.dischargingActDt
                                        ? _c(
                                            "p",
                                            { staticClass: "color_red" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.fnEaDateTime(
                                                    _vm.legSummary
                                                      .dischargingActDt,
                                                    "A"
                                                  )
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                                    _c("td", { staticClass: "td_left_line" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.isVepCgo
                                            ? "-"
                                            : _vm.fnCntRate(
                                                _vm.legSummary.podFulOutCnt,
                                                _vm.legSummary.totCnt
                                              )
                                        )
                                      ),
                                    ]),
                                    _c("td", { staticClass: "td_left_line" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.isVepCgo
                                            ? "-"
                                            : _vm.fnCntRate(
                                                _vm.legSummary.podMtyInCnt,
                                                _vm.legSummary.totCnt
                                              )
                                        )
                                      ),
                                    ]),
                                    _c(
                                      "td",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.registryNo === "Y",
                                            expression: "registryNo === 'Y'",
                                          },
                                        ],
                                        staticClass: "td_left_line",
                                      },
                                      [_vm._v(_vm._s(_vm.summaryMrnNo))]
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm.searchFlag === "Y" &&
                  _vm.noDataFlag === "N" &&
                  _vm.legDetailList.length > 0
                    ? _c("div", { staticClass: "mt25" }, [
                        _vm._m(1),
                        _c(
                          "table",
                          {
                            staticClass: "tbl_col mt5",
                            staticStyle: { "table-layout": "fixed" },
                          },
                          [
                            _c(
                              "colgroup",
                              _vm._l(
                                _vm.vesselDetailColWidths,
                                function (w, widx) {
                                  return _c("col", {
                                    key: "vdCol_" + widx,
                                    style: { width: w },
                                  })
                                }
                              ),
                              0
                            ),
                            _c("thead", [
                              _c("tr", [
                                _c("th", [_vm._v("Seq")]),
                                _c("th", [
                                  _vm._v(_vm._s(_vm.$t("msg.CART010G010.019"))),
                                ]),
                                _c("th", [
                                  _vm._v(_vm._s(_vm.$t("msg.CART010G010.017"))),
                                ]),
                                _c("th", [
                                  _vm._v(_vm._s(_vm.$t("msg.CART010G010.083"))),
                                ]),
                                _c("th", [
                                  _vm._v(_vm._s(_vm.$t("msg.CART010G010.018"))),
                                ]),
                                _c("th", [
                                  _vm._v(_vm._s(_vm.$t("msg.CART010G010.083"))),
                                ]),
                                _c("th", [
                                  _vm._v(_vm._s(_vm.$t("msg.CART010G010.084"))),
                                ]),
                                _c("th", [
                                  _vm._v(_vm._s(_vm.$t("msg.CART010G010.085"))),
                                ]),
                                _c("th", [
                                  _vm._v(_vm._s(_vm.$t("msg.CART010G010.086"))),
                                ]),
                                _vm.showReserveConfirm
                                  ? _c("th", [
                                      _vm._v(
                                        _vm._s(_vm.$t("msg.CART010G010.020")) +
                                          "/"
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        _vm._s(_vm.$t("msg.CART010G010.021"))
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                            ]),
                            _c(
                              "tbody",
                              _vm._l(_vm.legDetailList, function (leg, lidx) {
                                return _c("tr", { key: "legDetail_" + lidx }, [
                                  _c("td", [_vm._v(_vm._s(leg.legSeq))]),
                                  _c("td", { staticClass: "td_left_line" }, [
                                    _vm._v(_vm._s(leg.vslNm)),
                                  ]),
                                  _c("td", { staticClass: "td_left_line" }, [
                                    leg.polPortCd
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "label blue md",
                                            attrs: {
                                              title: leg.polPortNm || null,
                                            },
                                          },
                                          [_vm._v(_vm._s(leg.polPortCd))]
                                        )
                                      : _vm._e(),
                                  ]),
                                  _c(
                                    "td",
                                    { staticClass: "td_left_line td_wrap" },
                                    [_vm._v(_vm._s(leg.polTrmlNm))]
                                  ),
                                  _c("td", { staticClass: "td_left_line" }, [
                                    leg.podPortCd
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "label blue md",
                                            attrs: {
                                              title: leg.podPortNm || null,
                                            },
                                          },
                                          [_vm._v(_vm._s(leg.podPortCd))]
                                        )
                                      : _vm._e(),
                                  ]),
                                  _c(
                                    "td",
                                    { staticClass: "td_left_line td_wrap" },
                                    [_vm._v(_vm._s(leg.podTrmlNm))]
                                  ),
                                  _c("td", { staticClass: "td_left_line" }, [
                                    leg.departureEstDt
                                      ? _c(
                                          "p",
                                          {
                                            class: leg.departureActDt
                                              ? "color_gray"
                                              : "",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.fnEaDateTime(
                                                  leg.departureEstDt,
                                                  "E"
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    leg.departureActDt
                                      ? _c("p", { staticClass: "color_red" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.fnEaDateTime(
                                                leg.departureActDt,
                                                "A"
                                              )
                                            )
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]),
                                  _c("td", { staticClass: "td_left_line" }, [
                                    leg.arrivalEstDt
                                      ? _c(
                                          "p",
                                          {
                                            class: leg.arrivalActDt
                                              ? "color_gray"
                                              : "",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.fnEaDateTime(
                                                  leg.arrivalEstDt,
                                                  "E"
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    leg.arrivalActDt
                                      ? _c("p", { staticClass: "color_red" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.fnEaDateTime(
                                                leg.arrivalActDt,
                                                "A"
                                              )
                                            )
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]),
                                  _c(
                                    "td",
                                    { staticClass: "td_left_line" },
                                    [
                                      leg.berthingTargetYn === "N"
                                        ? [_vm._v("-")]
                                        : [
                                            leg.berthingEstDt
                                              ? _c(
                                                  "p",
                                                  {
                                                    class: leg.berthingActDt
                                                      ? "color_gray"
                                                      : "",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.fnEaDateTime(
                                                          leg.berthingEstDt,
                                                          "E"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            leg.berthingActDt
                                              ? _c(
                                                  "p",
                                                  { staticClass: "color_red" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.fnEaDateTime(
                                                          leg.berthingActDt,
                                                          "A"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                    ],
                                    2
                                  ),
                                  _vm.showReserveConfirm
                                    ? _c(
                                        "td",
                                        { staticClass: "td_left_line" },
                                        [
                                          _vm.legConfirmCds[lidx] === "01"
                                            ? _c(
                                                "span",
                                                { staticClass: "label red md" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "msg.CART010G010.022"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.legConfirmCds[lidx] === "02"
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass: "label green md",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "msg.CART010G010.023"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.legConfirmCds[lidx] === "03"
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass: "label gray md",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "msg.CART010G010.024"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              }),
                              0
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm.rsChVesselList.length > 0 &&
                  (_vm.bookingInfo.polCtrCd === "JP" ||
                    _vm.bookingInfo.podCtrCd === "JP")
                    ? _c(
                        "p",
                        { staticClass: "txt_desc color_black" },
                        _vm._l(_vm.rsChVesselList, function (vo, idx) {
                          return _c("span", { key: "rsChvsList" + idx }, [
                            _vm._v(" " + _vm._s(vo.logCont) + " "),
                            _c("br"),
                          ])
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm.searchFlag !== "N"
                    ? _c("p", { staticClass: "txt_desc color_black" }, [
                        _vm._v(" " + _vm._s(_vm.$t("msg.CART010G010.025"))),
                        _c("br"),
                        _vm._v(" " + _vm._s(_vm.$t("msg.CART010G010.026"))),
                        _c("br"),
                        _vm._v(" " + _vm._s(_vm.$t("msg.CART010G010.027"))),
                        _c("br"),
                        _vm._v(" " + _vm._s(_vm.$t("msg.CART010G010.028"))),
                        _c("br"),
                        _vm._v(
                          " " + _vm._s(_vm.$t("msg.CART010G010.071")) + " "
                        ),
                      ])
                    : _vm._e(),
                  _vm.bookingInfo.podCtrCd === "JP" && _vm.lang === "JPN"
                    ? _c("div", [
                        _c("p", { staticClass: "txt_desc color_black" }, [
                          _vm._v(
                            " こちらのボタンから、A/Nについての問合せ先、実入りの搬出先、空バンの返却先などの詳細をご確認いただけます。 "
                          ),
                        ]),
                        _c(
                          "a",
                          {
                            staticClass: "button blue sh",
                            staticStyle: { margin: "5px" },
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.CargoTrackingJpPodInfoPopCall()
                              },
                            },
                          },
                          [_vm._v("POD INFORMATION( A/N 発行 所 / CY )")]
                        ),
                      ])
                    : _vm._e(),
                  _vm.detailFlag === "Y"
                    ? _c("div", { staticClass: "position_relative mt25" }, [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "margin-bottom": "8px",
                            },
                          },
                          [
                            _c(
                              "h2",
                              {
                                staticClass: "content_title",
                                staticStyle: {
                                  display: "inline-block",
                                  "margin-bottom": "0px !important",
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("msg.CART010G010.029")))]
                            ),
                            _vm.cargoEyeShowYn === "Y"
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "button blue sh",
                                    staticStyle: { "margin-left": "8px" },
                                    attrs: { href: "#" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.openCargoEye()
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("msg.CART010G010.060"))
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.rfTargetYn === "Y"
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "button blue sh",
                                    staticStyle: { "margin-left": "8px" },
                                    attrs: { href: "#" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.openRfDataInfoPop()
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("menu.MENU03.040")))]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c("span", { staticClass: "location_ico_update" }, [
                          _vm._v(
                            _vm._s(_vm.$t("msg.CART010G010.030")) +
                              " : " +
                              _vm._s(_vm.updateDate)
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.detailFlag === "Y"
                    ? _c("cargo-location-detail", {
                        ref: "loc",
                        attrs: {
                          "detail-params": _vm.detailParams,
                          "average-params": _vm.averageParams,
                          "detail-date-list": _vm.detailDateList,
                          "detail-list": _vm.detailList,
                          "detail-inland-list": _vm.inlandList,
                          "date-flag": _vm.dateFlag,
                          rank: _vm.rank,
                          lang: _vm.lang,
                          "dly-ctr-cd": _vm.dlyCtrCd,
                          "cy-cfs-yn": _vm.cyCfsYn,
                          "inland-list-in": _vm.inlandListIn,
                          "is-vep-cgo": _vm.isVepCgo,
                        },
                      })
                    : _vm._e(),
                  _vm.detailFlag === "Y" &&
                  _vm.showCargoEye() &&
                  _vm.isOpenCargoEye
                    ? _c("cargo-vessel-location", {
                        ref: "map",
                        attrs: { "bl-no": _vm.detailParams.blNo },
                      })
                    : _vm._e(),
                  _vm.detailFlag === "Y" && _vm.inlandList.length > 0
                    ? _c("h2", { staticClass: "content_title" }, [
                        _vm._v(_vm._s(_vm.$t("msg.CART010G010.031"))),
                      ])
                    : _vm._e(),
                  _vm.detailFlag === "Y" && _vm.inlandList.length > 0
                    ? _c("table", { staticClass: "tbl_col mt10" }, [
                        _vm._m(2),
                        _c("thead", [
                          _c("tr", [
                            _c("th", [
                              _vm._v(_vm._s(_vm.$t("msg.CART010G010.032"))),
                            ]),
                            _c("th", [
                              _vm._v(_vm._s(_vm.$t("msg.CART010G010.033"))),
                            ]),
                            _c("th", [
                              _vm._v(_vm._s(_vm.$t("msg.CART010G010.034"))),
                            ]),
                            _c("th", [
                              _vm._v(_vm._s(_vm.$t("msg.CART010G010.035"))),
                            ]),
                          ]),
                        ]),
                        _c(
                          "tbody",
                          _vm._l(_vm.inlandList, function (item) {
                            return _c("tr", { key: item.seq }, [
                              _c("td", [_vm._v(_vm._s(item.cntrNo))]),
                              _c("td", [_vm._v(_vm._s(item.eventCd))]),
                              _c("td", { staticClass: "text_left" }, [
                                _vm._v(_vm._s(item.plcNm)),
                              ]),
                              _c("td", [_vm._v(_vm._s(item.plcDtm))]),
                            ])
                          }),
                          0
                        ),
                      ])
                    : _vm._e(),
                  _vm.detailFlag === "Y" &&
                  _vm.bookingInfo.etd > _vm.bookingInfo.toDay
                    ? _c("close-info", {
                        ref: "closeInfo",
                        attrs: { "parent-info": _vm.closeParams },
                      })
                    : _vm._e(),
                  _c(
                    "win-layer-pop",
                    [
                      _vm.customComponent
                        ? _c(_vm.customComponent, {
                            tag: "component",
                            attrs: {
                              detail: _vm.detail,
                              "ok-hidden": _vm.isHidden,
                            },
                            on: { close: _vm.closePoup },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "win-layer-pop",
                    { staticClass: "ongoing-rf-list-popup" },
                    [
                      _vm.popupComponent
                        ? _c(_vm.popupComponent, {
                            tag: "component",
                            attrs: { "parent-info": _vm.popupParams },
                            on: {
                              close: _vm.closeRfPopup,
                              callback: _vm.popupCallback,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "win-layer-pop",
                    { staticClass: "subscription-pop" },
                    [
                      _vm.subscriptionPopupComponent
                        ? _c(_vm.subscriptionPopupComponent, {
                            tag: "component",
                            attrs: {
                              "parent-info": _vm.subscriptionPopupParams,
                            },
                            on: {
                              close: _vm.closeSubscriptionPopup,
                              callback: _vm.subscriptionPopupCallback,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.searchFlag === "Y" && _vm.noDataFlag === "Y"
            ? _c("div", [
                _c("table", { staticClass: "tbl_col mt10 th_pre_line" }, [
                  _vm._m(3),
                  _c("thead", [
                    _c("tr", [
                      _c("th", [
                        _vm._v(_vm._s(_vm.$t("msg.CART010G010.012"))),
                        _c("br"),
                        _vm._v(
                          _vm._s("(" + _vm.$t("msg.ONEX010T010.093") + ")")
                        ),
                      ]),
                      _c("th", [_vm._v(_vm._s(_vm.$t("msg.CART010G010.014")))]),
                      _c("th", [_vm._v(_vm._s(_vm.$t("msg.CART010G010.013")))]),
                      _c("th", [_vm._v(_vm._s(_vm.$t("msg.CART010G010.016")))]),
                      _c("th", [_vm._v("CGO")]),
                      _c("th", [_vm._v(_vm._s(_vm.$t("msg.CART010G010.077")))]),
                      _c("th", [_vm._v(_vm._s(_vm.$t("msg.CART010G010.078")))]),
                      _c("th", [_vm._v(_vm._s(_vm.$t("msg.CART010G010.079")))]),
                      _c("th", [_vm._v(_vm._s(_vm.$t("msg.CART010G010.080")))]),
                      _c("th", [_vm._v(_vm._s(_vm.$t("msg.CART010G010.081")))]),
                      _c("th", [_vm._v(_vm._s(_vm.$t("msg.CART010G010.082")))]),
                    ]),
                  ]),
                  _c("tbody", [
                    _c("tr", [
                      _c("td", { attrs: { colspan: "11" } }, [
                        _vm._v(_vm._s(_vm.$t("msg.CART010G010.056"))),
                      ]),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { staticClass: "wid60" }),
      _c("col", { staticClass: "wid200" }),
      _c("col", { staticClass: "wid260" }),
      _c("col"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "justify-content": "space-between",
          "align-items": "baseline",
        },
      },
      [
        _c(
          "h2",
          {
            staticClass: "content_title",
            staticStyle: { "margin-bottom": "0px !important" },
          },
          [_vm._v("[Vessel Detail]")]
        ),
        _c("p", { staticClass: "font_medium" }, [
          _vm._v("(E) Estimated  "),
          _c("span", { staticClass: "color_red" }, [_vm._v("(A) Actual")]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { staticStyle: { width: "20%" } }),
      _c("col", { staticStyle: { width: "18%" } }),
      _c("col", { staticStyle: { width: "44%" } }),
      _c("col", { staticStyle: { width: "18%" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { staticStyle: { width: "10%" } }),
      _c("col", { staticStyle: { width: "9%" } }),
      _c("col", { staticStyle: { width: "11%" } }),
      _c("col", { staticStyle: { width: "6%" } }),
      _c("col", { staticStyle: { width: "4%" } }),
      _c("col", { staticStyle: { width: "7%" } }),
      _c("col", { staticStyle: { width: "7%" } }),
      _c("col", { staticStyle: { width: "14%" } }),
      _c("col", { staticStyle: { width: "14%" } }),
      _c("col", { staticStyle: { width: "9%" } }),
      _c("col", { staticStyle: { width: "9%" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }